import { Ornt, widgetType, WidgetDate, WidgetText, WidgetImage, ListWidget, WidgetStack, WidgetSpacer } from '../types';
import genID from '../util/genID';

interface WidgetList {
	[widgetType.DATE]: WidgetDate;
	[widgetType.TEXT]: WidgetText;
	[widgetType.IMAGE]: WidgetImage;
	[widgetType.SPACER]: WidgetSpacer;
	[widgetType.STACK]: WidgetStack;
	[widgetType.LIST]: ListWidget;
}

export default (type: widgetType) => {
	// 在这里设置每个组件创建时的属性默认值
	const widgetList: WidgetList = {
		[widgetType.DATE]: {
			id: genID(),
			type: widgetType.DATE,
			text: '请选择日期',
			attrs: {
				date: '',
				font: {
					size: 16,
					type: '',
				},
				shadowColor: '#000',
				shadowOffset: {
					x: 0,
					y: 0,
				},
				shadowRadius: 0,
				textColor: '#fff',
				textOpacity: 1,
				lineLimit: 0,
				url: '',
				style: 'date',
				alignText: 'flex-start',
				minimumScaleFactor: 1,
			},
			size: {
				[Ornt.X]: 0,
				[Ornt.Y]: 0,
			},
		},
		[widgetType.IMAGE]: {
			id: genID(),
			type: widgetType.IMAGE,
			attrs: {
				image: './test1.jpg',
				borderColor: '#000',
				borderWidth: 0,
				imageOpacity: 1,
				cornerRadius: 0,
				imageSize: {
					[Ornt.X]: 0,
					[Ornt.Y]: 0,
				},
				tint: {
					color: '#000',
					opacity: 0,
				},
				contentMode: 'fit',
				alignImage: 'flex-start',
				url: '',
				containerRelativeShape: false,
				resizable: true,
			},
			size: {
				[Ornt.X]: 0,
				[Ornt.Y]: 0,
			},
			rawImageDate: '',
			rawImageSize: {
				[Ornt.X]: 0,
				[Ornt.Y]: 0,
			},
		},
		[widgetType.TEXT]: {
			id: genID(),
			type: widgetType.TEXT,
			attrs: {
				text: '请输入文本',
				font: {
					size: 16,
					type: '',
				},
				shadowColor: '#000',
				shadowOffset: {
					x: 0,
					y: 0,
				},
				shadowRadius: 0,
				textColor: '#fff',
				textOpacity: 1,
				lineLimit: 0,
				url: '',
				alignText: 'flex-start',
				minimumScaleFactor: 1,
			},
			size: {
				[Ornt.X]: 0,
				[Ornt.Y]: 0,
			},
		},
		[widgetType.SPACER]: {
			id: genID(),
			type: widgetType.SPACER,
			attrs: {
				length: 0,
			},
			size: {
				[Ornt.X]: 0,
				[Ornt.Y]: 0,
			},
		},
		[widgetType.LIST]: {
			id: genID(),
			type: widgetType.LIST,
			bgImageDate: '',
			attrs: {
				backgroundColor: '#000',
				backgroundGradient: {
					colors: '',
					locations: '',
					angle: 90,
				},
				backgroundImage: '',
				spacing: 0,
				padding: {
					top: 20,
					left: 20,
					bottom: 20,
					right: 20,
				},
				url: '',
				refreshAfterDate: '',
			},
			size: {
				[Ornt.X]: 320,
				[Ornt.Y]: 149,
			},
			showNodes: [],
			realNodes: [],
		},
		[widgetType.STACK]: {
			id: genID(),
			type: widgetType.STACK,
			bgImageDate: '',
			attrs: {
				size: {
					[Ornt.X]: 0,
					[Ornt.Y]: 0,
				},
				backgroundColor: '',
				backgroundGradient: {
					colors: '',
					locations: '',
					angle: 90,
				},
				backgroundImage: '',
				borderColor: '#fff',
				borderWidth: 1,
				cornerRadius: 0,
				spacing: 0,
				padding: {
					top: 0,
					left: 0,
					bottom: 0,
					right: 0,
				},
				url: '',
				layout: Ornt.X,
				alignContent: 'flex-start',
			},
			size: {
				[Ornt.X]: 0,
				[Ornt.Y]: 0,
			},
			showNodes: [],
			realNodes: [],
		},
	};
	return widgetList[type];
};
